import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  ErrorStateService,
  Ticket,
  TicketService,
  DeliveryParameters,
  TicketActionType,
  TicketFlag,
  TicketDetails,
} from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

@Component({
  selector: 'fgbcl-ticket-list-item',
  templateUrl: './ticket-list-item.component.html',
  styleUrls: ['./ticket-list-item.component.scss'],
})
export class TicketListItemComponent implements OnInit {
  @Input() ticket: Ticket;
  @Input() transferWindowExists: boolean;
  @Input() transferWindowOpen: boolean;
  @Input() ticketColumn1: TicketDetails = TicketDetails.Area;
  @Input() ticketColumn2: TicketDetails = TicketDetails.Stand;

  ticketDetails = TicketDetails;

  ticketFlag = TicketFlag;
  loading: boolean;
  subscription: Subscription = new Subscription();

  constructor(
    private modalService: NgbModal,
    private ticketService: TicketService,
    private router: Router,
    private errorStateService: ErrorStateService
  ) {}

  ngOnInit() {}

  checkFlag(status: number, flag: number) {
    // tslint:disable-next-line: no-bitwise
    return status & flag;
  }

  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'ticket-transfer-callback-modal', centered: true });
  }

  toggleSelectTicket(id: string) {
    this.ticketService.toggleSelectTicket(id);
  }

  callbackTicket() {
    this.loading = true;
    
    let deliveryParameters = new DeliveryParameters();
    deliveryParameters.TicketAction = TicketActionType.Callback;

    this.subscription = this.ticketService.callbackTicket(this.ticket, deliveryParameters).subscribe((result) => {
      if (result && result.length > 0) {
        if (result[0].Result.ErrorNumber === 0) {
          this.modalService.dismissAll();
          this.router.navigate(['ticketTransfer/tickets/' + this.ticket.GameNumber]);
        } else {
          this.errorStateService.addError(`Error: Callback failed. Description: ${result[0].Result.ErrorDescription}`);
          setTimeout(() => {
            this.errorStateService.clearErrors();
            this.loading = false;
          }, 3000);
        }
      } else {
        this.errorStateService.addError(`Error: Callback failed.`);
        setTimeout(() => {
          this.errorStateService.clearErrors();
          this.loading = false;
        }, 3000);
      }
    });
  }
}
